export const COUNTRY = 'country';
export const COUNTRY_CODE = 'country_code';
export const E_CUSTOMER_TYPE = 'e_customer_type';
export const CUSTOMER_NAME = 'customer_name';
export const PRODUCT_SUPPLIER = 'product_supplier';
export const SAP_CODE = 'sap_code';
export const CODE_HIERARHY = 'code_hierarhy';
export const DIRECT_INDIRECT = 'direct_indirect';
export const SELLES_DATA_SHARING = 'selles_data_sharing';
export const SELL_DATA_MESH = 'sell_out_data_processed';
export const FREQUENCY_DATA_SHARING = 'frequency_of_data_sharing';
export const DATA_REPORTING_ESTIMATION = 'data_for_reporting_estimation';
export const PRIORITY = 'priority';
export const PFP_IMPLEMENTATION = 'pfp_implementation';
export const DESCRIBE_PLANNED = 'describe_planned';
export const ERED_ERETAIL = 'ered_eretail';
export const ERED_FSA = 'ered_fsa';
export const ERED_QC = 'ered_qc';
export const ERED_QSR = 'ered_qsr';
export const MEDIA_HOUSE = 'media_house';
export const RETAIL_MEDIA = "retail_media";
export const MARKET_SHARES = 'market_shares';
export const CUSTOMER_URL = 'customer_url';
export const COLLABORATIVE_ADS = "collaborative_ads";
export const ORDERING_CHANNEL = "ordering_channel";
export const ONSITE_RETAIL_MEDIA = "onsite_retail_media";
export const SHARED_DATA_WITH_CUSTOMERS = "shared_data_with_customers";
export const DIGITAL_TOOLS_OFFERED = "digital_tools_offered";


export const DEFAULT_COLUMNS = [
    // {
	// 	dataIndex: COUNTRY,
	// 	title: "Country",
	// 	width: '8%',
	// 	editable: false,
	// 	fixed: 'left',
    // },
    {
		dataIndex: E_CUSTOMER_TYPE,
		title: "Type of eCustomer",
		width: 120,
		editable: true,
		fixed: 'left',
    },
    {
		dataIndex: CUSTOMER_NAME,
		title: "Customer Name",
		width: 200,
		editable: true,
		fixed: 'left',
    },
    {
		dataIndex: PRODUCT_SUPPLIER,
		title: "Product Supplier",
        width: 260,
		editable: true,
    },
    {
		dataIndex: SAP_CODE,
		title: "CPL/Customer SAP code",
        width: 260,
		editable: true,
    },
    {
		dataIndex: CODE_HIERARHY,
		title: "Code hierarchy",
        width: 260,
		editable: true,
    },
    {
		dataIndex: DIRECT_INDIRECT,
		title: "Direct/Indirect",
        width: 120,
		editable: true,
    },
    {
		dataIndex: SELLES_DATA_SHARING,
		title: "Sales Data sharing",
		width: 160,
		editable: true,
    },
    {
		dataIndex: SELL_DATA_MESH,
		title: "Sell out data processed",
		width: 160,
		editable: true,
    },
    {
		dataIndex: FREQUENCY_DATA_SHARING,
		title: "Frequency of Data Sharing (every week, month, bi-monthly, quarterly, semi-annualy, etc)",
		width: 360,
		editable: true,
    },
    {
		dataIndex: DATA_REPORTING_ESTIMATION,
		title: "Data for reporting estimation list",
		width: 320,
		editable: true,
    },
    {
		dataIndex: PRIORITY,
		title: "Priority",
		width: 120,
		editable: true,
    },
    {
		dataIndex: PFP_IMPLEMENTATION,
		title: "PfP implementation",
		width: 160,
		editable: true,
    },
    {
		dataIndex: DESCRIBE_PLANNED,
		title: "Describe planned (with deadline)/factual PfP implemented",
		width: 240,
		editable: true,
    },
    {
      	dataIndex: ERED_ERETAIL,
		title: "eRed for eRetail",
		width: 140,
		editable: true,
    },
    {
		dataIndex: ERED_FSA,
		title: "eRed for FSA",
		width: 140,
		editable: true,
    },
    {
		dataIndex: ERED_QC,
		title: "eRed for QC",
		width: 140,
		editable: true,
    },
    {
		dataIndex: ERED_QSR,
		title: "eRed for QSR",
		width: 140,
		editable: true,
    },
    {
		dataIndex: MEDIA_HOUSE,
		title: "Media House available/in house sales",
		width: 180,
		editable: true,
    },
    {
		dataIndex: RETAIL_MEDIA,
		title: "Collaboration with external Media Agency",
		width: 180,
		editable: true,
    },
    {
		dataIndex: MARKET_SHARES,
		title: "Market shares data sharing",
		width: 160,
		editable: true,
    },
    {
		dataIndex: CUSTOMER_URL,
		title: "Customer URL",
		width: 260,
		editable: true,
    },
    {
		dataIndex: COLLABORATIVE_ADS,
		title: "Collaborative ads",
		width: 160,
		editable: true,
    },
    {
		dataIndex: ORDERING_CHANNEL,
		title: "Ordering channel (EDI, Direct, CP, WHS)",
		width: 160,
		editable: true,
    },
    {
		dataIndex: ONSITE_RETAIL_MEDIA,
		title: "Onsite retail media available",
		width: 160,
		editable: true,
    },
    {
		dataIndex: SHARED_DATA_WITH_CUSTOMERS,
		title: "If Y, which data can be shared by customers from the below list? ( Sales uplift, Market Share, New to Brand, Basket Incidence, Repeat Purchase, ROAs)",
		width: 260,
		editable: true,
    },
    {
		dataIndex: DIGITAL_TOOLS_OFFERED,
		title: "If Y which digital tools are offered to suppliers for RM activation?",
		width: 260,
		editable: true,
    },
];

export const COLUMNS_FOR_EXPORT = [
	{
		key: 'country',
		label: 'Country'
	}
]

export const BOOL_DROPDOWN = [
	{
        value: false,
        label: 'No'
	},
	{
        value: true,
        label: 'Yes'
	}
];
export const BOOL_COLUMNS = [
	MEDIA_HOUSE,
	RETAIL_MEDIA,
	MARKET_SHARES,
	COLLABORATIVE_ADS,
	ONSITE_RETAIL_MEDIA,
];


export const CODE_HIERARHY_DROPDOWN = [
    {
        value: 'customer_hierarchy_6_id',
        label: 'customer_hierarchy_6_id'
    },
    {
        value: 'customer_hierarchy_5_id',
        label: 'customer_hierarchy_5_id'
    },
    {
        value: 'dummy code by Group',
        label: 'dummy code by Group'
    },
    {
        value: 'customer ID',
        label: 'customer ID'
    },
    {
        value: 'no data',
        label: 'no data'
    },
]

export const PRIORITY_DROPDOWN = [
    {
        value: 'Low',
        label: 'Low'
    },
    {
        value: 'Medium',
        label: 'Medium'
    },
    {
        value: 'High',
        label: 'High'
    }
];

export const SELLES_DATA_SHARING_DROPDOWN = [
	{
        value: 'Yes',
        label: 'Yes'
	},
	{
        value: 'No',
        label: 'No'
	},
	{
        value: 'yes, central',
        label: 'yes, central'
	},
	{
        value: 'by request',
        label: 'by request'
	},
	{
        value: 'Planned Q1',
        label: 'Planned Q1'
	},
	{
        value: 'Planned Q2',
        label: 'Planned Q2'
	},
	{
        value: 'Planned Q3',
        label: 'Planned Q3'
	},
	{
        value: 'Planned Q4',
        label: 'Planned Q4'
	},
]

export const PFP_IMPLEMENTATION_DROPDOWN = [
	{
        value: 'Yes',
        label: 'Yes'
	},
	{
        value: 'No',
        label: 'No'
	},
	{
        value: 'Planned',
        label: 'Planned'
	},
	{
        value: 'Planned Q1',
        label: 'Planned Q1'
	},
	{
        value: 'Planned Q2',
        label: 'Planned Q2'
	},
	{
        value: 'Planned Q3',
        label: 'Planned Q3'
	},
	{
        value: 'Planned Q4',
        label: 'Planned Q4'
	},
    {
        value: 'no data',
        label: 'no data'
    },
]

export const DATA_REPORTING_ESTIMATION_DROPDOWN = [
	{
        value: 'Channel contribution, %',
        label: 'Channel contribution, %'
	},
	{
        value: 'Customer contribution, %',
        label: 'Customer contribution, %'
	},
	{
        value: 'sell out',
        label: 'sell out'
	},
	{
        value: 'sell in',
        label: 'sell in'
	},
	{
        value: 'estimation in comparison with another player',
        label: 'estimation in comparison with another player'
	},
]

export const EREDS_COLUMNS = [
	ERED_ERETAIL,
	ERED_FSA,
	ERED_QC,
	ERED_QSR,
]

export const EREDS_DROPDOWN = [
	{
        value: 'Yes',
        label: 'Yes',
	},
	{
        value: 'No',
        label: 'No',
	},
	{
        value: 'planned',
        label: 'planned',
	},
	{
        value: 'Q1',
        label: 'Q1',
	},
	{
        value: 'Q2',
        label: 'Q2',
	},
	{
        value: 'Q3',
        label: 'Q3',
	},
	{
        value: 'Q4',
        label: 'Q4',
	},
	{
        value: 'not feasible',
        label: 'not feasible',
	},
	{
        value: 'not relevant',
        label: 'not relevant',
	},
	{
        value: 'pilot',
        label: 'pilot',
	},
]

export const DIRECT_INDIRECT_COLUMNS = [
	{
        value: true,
        label: 'Direct',
	},
	{
        value: false,
        label: 'Indirect',
	},
]

export const SELL_DATA_MESH_DROPDOWN = [
	{
        value: 'not provided',
        label: 'not provided',
	},
	{
        value: 'Yes',
        label: 'Yes',
	},
	{
        value: 'No',
        label: 'No',
	},
	{
        value: 'wip',
        label: 'wip',
	},
]

export const DROPDOWN_COLUMNS = [
    PRIORITY,
	E_CUSTOMER_TYPE,
	SELLES_DATA_SHARING,
	PFP_IMPLEMENTATION,
	DATA_REPORTING_ESTIMATION,
	DIRECT_INDIRECT,
	CODE_HIERARHY,
	SELL_DATA_MESH,
	...BOOL_COLUMNS,
	...EREDS_COLUMNS,
]